import { create } from 'zustand';

interface NavStoreState {
  navbarOpened: boolean;
  setNavbarOpened: (navbarOpened: boolean) => void;
}

export const useNavStore = create<NavStoreState>((set, get) => ({
  navbarOpened: false,
  setNavbarOpened: (navbarOpened) => set({ navbarOpened }),
}));
